import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {availableDishesActions} from "../store/slices/menu-slices";

export const useInitCalendarDate = () => {
    const dispatch = useDispatch();
    const dataOfDay = useSelector(state => state.availableDishes.dataOfDay);

    useEffect(() => {
        if (!dataOfDay) {
            const saved = localStorage.getItem("availableDishesSelectedDate");
            if (saved) {
                dispatch(availableDishesActions.changeDataOfDay(saved));
            } else {
                const today = new Date().toISOString().split("T")[0];
                dispatch(availableDishesActions.changeDataOfDay(today));
            }
        }
    }, [dataOfDay, dispatch]);
};
